
import { defineComponent } from 'vue'
import Navbar from './components/Shared/Navbar.vue'

export default defineComponent({
  components: {
    Navbar,
  },
  mounted() {
    document.title = 'Shin'
  },
})
